export default "__VITE_ASSET__aa5160d5__"